import React, {PropsWithChildren} from "react";
import styled from "styled-components";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";

interface IAspectRatioBoxProps {
    expectedWidth: number;
    expectedHeight: number;
}

const AspectRatioBox = styled.div<IAspectRatioBoxProps>`
    position: relative;
    width: 100%;
    height: 0;
    padding-top: calc(${({expectedWidth, expectedHeight}) => `${expectedHeight} / ${expectedWidth} * 100%`});
`;

interface IAspectRatioContentBoxProps {
    isLoading?: boolean;
    useBGColorDuringLoadAnimation?: boolean;
}

const AspectRatioContentBox = styled.div<IAspectRatioContentBoxProps>`
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    opacity: 0;

    ${(props) => props.useBGColorDuringLoadAnimation && props.isLoading && `background-color: ${props.theme.colors.backgroundDark}`};

    animation: ${({isLoading}) => isLoading ? "LoadingAnimation 1.5s linear 3 forwards" : "RevealAnimation 0.5s ease-out forwards"};

    @keyframes LoadingAnimation {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes RevealAnimation {
        to {
            opacity: 1;
        }
    }
`;

interface IAspectRatioContainerComponentProp extends PropsWithChildren {
    width: number;
    height: number;
    isLoading?: boolean;
    useBGColorDuringLoadAnimation?: boolean;
}

export class AspectRatioContainerComponent extends OrbitComponent<IAspectRatioContainerComponentProp> {
    render() {
        return (
            <AspectRatioBox expectedWidth={this.props.width} expectedHeight={this.props.height}>
                <AspectRatioContentBox isLoading={this.props.isLoading} useBGColorDuringLoadAnimation={this.props.useBGColorDuringLoadAnimation}>
                    {this.props.children}
                </AspectRatioContentBox>
            </AspectRatioBox>
        );
    }
}
